var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDeleteButton = function SvgDeleteButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .delete-svg-style {\r\n        fill: none;\r\n        stroke: #ff5a29;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "delete-svg-style",
    height: 22,
    width: 18,
    x: 7,
    y: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "delete-svg-style",
    x1: 3,
    x2: 29,
    y1: 7,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "delete-svg-style",
    x1: 13,
    x2: 19,
    y1: 3,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    className: "delete-svg-style",
    x1: 13,
    x2: 13,
    y1: 12,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "delete-svg-style",
    x1: 19,
    x2: 19,
    y1: 12,
    y2: 22
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-button.7ce6f55c.svg";
export { ForwardRef as ReactComponent };